/*
*  this function check view data
*  example 1 => 01, 
*  2020-1-4  => 2020-01-04
*/
const checkDateView = date => date < 10 ? '0' + date : date

/*
*  this function convert unixTimestamp data to "YYYY-MM-DD HH:mm:ss" format
*/
const dateConverter = paramsDate => {
    const date = paramsDate ? new Date(paramsDate) : new Date
    const year = date.getFullYear();
    const month = checkDateView(date.getMonth() + 1);
    const monthDay = checkDateView(date.getDate());
    const hour = checkDateView(date.getHours());
    const minutes = checkDateView(date.getMinutes());
    const seconds = checkDateView(date.getSeconds());
    //"YYYY-MM-DD HH:mm:ss" format
    return `${year}-${month}-${monthDay} ${hour}:${minutes}:${seconds}`
}
export default dateConverter